module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/p3_title.639c5c24.png";